import React, { Fragment, ReactNode } from 'react';

import t from '../../../labels/labelling-utils';
import { IComponent } from '../../../typings/generic-component';
import { DRIVERFLAG, placeholdersMap } from '../../../utils/placeholders-motorsports';
import { makeClassNames } from '../../../utils/styles';
import ImgPlaceholder from '../../atoms/img-placeholder/img-placeholder';
import Table, { IColumn, IRow } from '../../molecules/table/table';
import { Trend } from '../../atoms';

import './tennis-tour-ranking.scss';

interface ITennisPlayerRow extends IRow, Omit<ITennisPlayer, 'trend'> {
  nameAndFlag: ReactNode;
  trend: ReactNode;
}

export interface ITennisPlayer {
  position: number;
  flagUrl: string;
  name: string;
  score: number;
  id: string;
  trend: number;
}

export interface ITennisTourRanking extends IComponent {
  ranking: ITennisPlayer[];
}

const classNames = () =>
  makeClassNames({
    root: 'tennis-tour-ranking',
  });

const columns: IColumn[] = [
  {
    title: t('tennis.tour.ranking.table.pos'),
    data: 'position',
    classModifier: 'position',
  },
  {
    title: '',
    data: 'trend',
    classModifier: 'trend',
  },
  {
    title: t('tennis.tour.ranking.table.name'),
    data: 'nameAndFlag',
    classModifier: 'name',
  },
  {
    title: t('tennis.tour.ranking.table.score'),
    data: 'score',
    classModifier: 'score',
  },
];

const TennisTourRanking = ({ ranking }: ITennisTourRanking) => {
  const cn = classNames();
  const rows: ITennisPlayerRow[] = ranking.map((player) => ({
    ...player,
    trend: <Trend value={player.trend} />,
    nameAndFlag: (
      <Fragment>
        <ImgPlaceholder src={player.flagUrl} placeholder={placeholdersMap[DRIVERFLAG]} aria-hidden="true" />{' '}
        {player.name}{' '}
      </Fragment>
    ),
  }));
  return (
    <div className={cn.root}>
      <Table rows={rows} columns={columns} showTitles />
    </div>
  );
};

export default TennisTourRanking;
